goog.provide("shadow.js.shim.module$react_simple_code_editor");
goog.provide("module$shadow_js_shim_module$react_simple_code_editor");
shadow.js.shim.module$react_simple_code_editor = shadow.js.nativeProvides["react-simple-code-editor"] = shadow$bridge("react-simple-code-editor");
module$shadow_js_shim_module$react_simple_code_editor.default = shadow.js.shim.module$react_simple_code_editor;
